<ion-item lines="none" (click)="onClick.emit(driver)" class="ion-margin-vertical">
  <div class="search-result name">
    {{ driverToString(driver) }}
  </div>
  <div class="search-result email">{{ driver.email }}</div>
</ion-item>
